import Vue from "vue";
import VueRouter from "vue-router";
import LAYOUT from "../layout/index.vue";
import QIANKUN from "@/views/qiankun/index.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
    component: LAYOUT,
    children: [
      {
        path: "/home",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/home/index.vue"),
        meta: { title: "首页" },
      },
      {
        path: "/search/*",
        name: "Search",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/search/index.vue"),
        meta: { title: "搜索" },
      },
      {
        path: "/teaching-resources",
        name: "TeachingResources",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/teaching-resources/index.vue"
          ),
        meta: { title: "教学资源" },
      },
      {
        path: "/teaching-resources/course-detail",
        name: "CourseDetail",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/teaching-resources/course-detail.vue"
          ),
        meta: { title: "课程详情" },
      },
      {
        path: "/teaching-resources/book-detail",
        name: "BookDetail",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/teaching-resources/book-detail.vue"
          ),
        meta: { title: "图书教材详情" },
      },
      {
        path: "/teaching-resources/virtual-simulation-detail",
        name: "VirtualSimulationDetail",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/teaching-resources/virtual-simulation-detail.vue"
          ),
        meta: { title: "虚拟仿真详情" },
      },
      {
        path: "/ai-tools",
        name: "AiTools",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/ai-tools/index.vue"),
        meta: { title: "AI工具" },
      },

      {
        path: "/event-activities",
        name: "EventActivities",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/event-activities/index.vue"
          ),
        meta: { title: "赛事活动" },
      },
      {
        path: "/topic-zone",
        name: "TopicZone",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/topic-zone/index.vue"
          ),
        meta: { title: "话题专区" },
      },
      {
        path: "/topic-zone/detail",
        name: "TopicDetail",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/topic-zone/detail.vue"
          ),
        meta: { title: "话题/资讯详情" },
      },
      {
        path: "/notice-announcement",
        name: "NoticeAnnouncement",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/notice-announcement/index.vue"
          ),
        meta: { title: "通知公告" },
      },
      {
        path: "/notice-announcement/detail",
        name: "NoticeAnnouncementDetail",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/notice-announcement/detail.vue"
          ),
        meta: { title: "通知公告详情" },
      },
      {
        path: "/umi/*",
        meta: { title: "科普" },
        component: QIANKUN,
      },
      {
        path: "/classroom-interaction",
        name: "ClassroomInteraction",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/classroom-interaction/index.vue"
          ),
        meta: { title: "课堂互动" },
      },
      {
        path: "/outstanding-achievements",
        name: "OutstandingAchievements",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/outstanding-achievements/index.vue"
          ),
        meta: { title: "优秀成果" },
      },
      {
        path: "/classic-solution",
        name: "ClassicSolution",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/classic-solution/index.vue"
          ),
        meta: { title: "经典方案" },
      },
      {
        path: "/classic-solution/detail",
        name: "ClassicSolutionDetail",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/classic-solution/detail.vue"
          ),
        meta: { title: "经典方案详情" },
      },
      {
        path: "/expert-think-tank",
        name: "ExpertThinkTank",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/expert-think-tank/index.vue"
          ),
        meta: { title: "专家智库" },
      },
      {
        path: "/person-center/child-management/child-invite",
        name: "ChildInvite",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/person-center/child-management/child-invite.vue"
          ),
        meta: { title: "成员邀请" },
      },
      {
        path: "/person-center/class-management/class-invite",
        name: "ClassInvite",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/person-center/class-management/class-invite.vue"
          ),
        meta: { title: "成员邀请" },
      },
      {
        path: "/person-center",
        name: "PersonCenter",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/person-center/index.vue"
          ),
        meta: { title: "个人中心" },
        redirect: "/person-center/personal-information",
        children: [
          {
            path: "/person-center/personal-information",
            name: "PersonalInformation",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/personal-information/index.vue"
              ),
            meta: { title: "个人信息" },
          },
          {
            path: "/person-center/account-security",
            name: "AccountSecurity",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/account-security/index.vue"
              ),
            meta: { title: "账户安全" },
          },
          {
            path: "/person-center/account-security/edit-password",
            name: "SecurityEditPassword",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/account-security/edit-password.vue"
              ),
            meta: { title: "个人信息" },
          },
          {
            path: "/person-center/child-management",
            name: "ChildManagement",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/child-management/index.vue"
              ),
            meta: { title: "孩子管理" },
          },
          {
            path: "/person-center/class-management",
            name: "ClassManagement",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/class-management/index.vue"
              ),
            meta: { title: "班级管理" },
          },
          {
            path: "/person-center/event-registration",
            name: "EventRegistration",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/event-registration/index.vue"
              ),
            meta: { title: "赛事报名" },
          },
          {
            path: "/person-center/physical-fitness-record",
            name: "PhysicalFitnessRecord",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/physical-fitness-record/index.vue"
              ),
            meta: { title: "体测记录" },
          },
          {
            path: "/person-center/participatory-learning",
            name: "ParticipatoryLearning",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/participatory-learning/index.vue"
              ),
            meta: { title: "参与的学习" },
          },
          {
            path: "/person-center/my-collection",
            name: "MyCollection",
            component: () =>
              import(
                /* webpackChunkName: "about" */ "@/views/person-center/my-collection/index.vue"
              ),
            meta: { title: "我的收藏" },
          },
        ],
      },
    ],
  },
  {
    path: "/ai",
    name: "Ai",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/ai-tools/phone.vue"),
    meta: { title: "移动端AI工具" },
  },
  {
    path: "/ai-tools/random-roll-call",
    name: "RandomRollCall",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/ai-tools/random-roll-call/index.vue"
      ),
    meta: { title: "随机点名" },
  },
  {
    path: "/ai-tools/countdown",
    name: "Countdown",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/ai-tools/countdown/index.vue"
      ),
    meta: { title: "倒计时" },
  },
  {
    path: "/ai-tools/high-speed-camera",
    name: "HighSpeedCamera",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/ai-tools/high-speed-camera/index.vue"
      ),
    meta: { title: "虚拟高拍仪" },
  },
  {
    path: "/ai-tools/high-speed-camera/high-speed-scanner",
    name: "HighSpeedScanner",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/views/ai-tools/high-speed-camera/high-speed-scanner.vue"
      ),
    meta: { title: "虚拟高拍仪扫码" },
  },
  {
    path: "/yhxy",
    name: "Yhxy",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/home/yhxy.vue"),
    meta: { title: "用户协议" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "error",
    component: () => import("@/views/404.vue"),
    meta: { title: "暂无页面" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
